














































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import {
  UserInformations,
  UserSalesOrg
} from '@/services/connecteur'
import { ModalType } from '@/models/Enum'
import UserDisplay from './UserDisplay.vue'
import UserDelegations from './UserDelegations.vue'
import BaseVue from '../../mixins/BaseVue'
import serviceModule from '@/store/modules/ServiceModule'

@Component({
  components: {
    UserDisplay,
    UserDelegations
  }
})
export default class UserList extends Mixins(BaseVue) {
  public loading = false;
  public search = '';
  public listeUser: UserInformations[] = []
  public listeUserFiltre: UserInformations[] = []
  public displayDeactivated = false;
  public typeDelete: ModalType = ModalType.Delete;
  public typeAdd: ModalType = ModalType.Add;
  public typeUpdate: ModalType = ModalType.Update;
  public typeActivate: ModalType = ModalType.Reactivate;
  public modalMode: ModalType = ModalType.Add;
  public clickedUser: UserInformations = new UserInformations({ id: 0 });
  public dialog = false;
  public delegationsDialog = false;
  public pageOptions: any = [];
  public headers: any[] = [
    {
      text: this.$t('user.email').toString(),
      value: 'email'
    },
    { text: this.$t('user.salesOrg').toString(), value: 'userSalesOrg' },
    { text: this.$t('user.roles').toString(), value: 'roleModel.name' },
    { text: this.$t('user.actions').toString(), align: 'center', value: 'actions' }
  ]

  public created () {
    this.fetchData()
    this.pageOptions = JSON.parse(`${process.env.VUE_APP_PER_PAGE_OPTIONS}`)
  }

  public parseSalesOrg (listeUserSalesOrg: UserSalesOrg[] = []) {
    const arrayRetour: string[] = []
    listeUserSalesOrg.forEach(element => {
      if (element.salesOrg) {
        arrayRetour.push(element.salesOrg.description)
      }
    })
    return arrayRetour.join(', ')
  }

  public updateListUser () {
    this.listeUserFiltre = []
    this.listeUser.forEach((element: UserInformations) => {
      if (this.displayDeactivated || !element.desactivated) {
        this.listeUserFiltre.push(element)
      }
    })
  }

  public fetchData () {
    this.loading = true
    serviceModule.userApi.getAllUser().then((response: UserInformations[]) => {
      this.loading = false
      this.listeUser = response
      this.updateListUser()
    }).catch((err) => {
      this.loading = false
      this.displayError(err)
    })
  }

  public clickOpenModal (item: UserInformations | null, modalmode: ModalType) {
    if (item == null) {
      item = new UserInformations({ id: 0, keyUser: false })
    }
    this.modalMode = modalmode
    this.clickedUser = item
    this.dialog = true
  }

  public openDelegationsModal (item: UserInformations) {
    this.clickedUser = item
    this.delegationsDialog = true
  }

  @Watch('displayDeactivated')
  public ondisplayDeactivatedChanged () {
    this.updateListUser()
  }
}
